"use strict";

var storeService = angular.module('service.Wiki', []);

storeService.factory('wikiService', ['$http', 'halClient', 'appSettings', function($http, halClient, appSettings){
        
    var outOfHoursConditionsUrl = appSettings.apiBaseUri + "/wikiResponse/query-by-providerId?providerId=";
   
    return {       
        getOutOfHoursConditions: function(providerId){
            return halClient.$get(outOfHoursConditionsUrl + providerId);
        }
    }
}]);